import { UserRoleValue } from 'types/api';

export default (roles: UserRoleValue[] | string[] | undefined): string =>
  roles && roles[0] ? roles[0].toLowerCase() : 'read-only';
